import {
    GET_MAPPING_MASTER_LIST,
    GET_MAPPING_MASTER_LIST_SUCCESS,
    SAVE_MAPPING_MASTER,
    SAVE_MAPPING_MASTER_SUCCESS,
    MAPPING_MASTER_API_ERROR
} from "./actionType";

const INIT_STATE = {
    mappingList: [],
    postMsg: null,
    errorMsg: null,
    loading: false,
    saveBtnLoading: false
};

const MappingMasterReducer = (state = INIT_STATE, action) => {
    switch (action.type) {

        // GET LIST
        case GET_MAPPING_MASTER_LIST:
            return {
                ...state,
                loading: true
            };

        case GET_MAPPING_MASTER_LIST_SUCCESS:
            return {
                ...state,
                mappingList: action.payload,
                loading: false
            };

        // SAVE
        case SAVE_MAPPING_MASTER:
            return {
                ...state,
                saveBtnLoading: true,
                postMsg: null,
                errorMsg: null
            };

        case SAVE_MAPPING_MASTER_SUCCESS:
            return {
                ...state,
                postMsg: action.payload,
                saveBtnLoading: false
            };

        // ERROR
        case MAPPING_MASTER_API_ERROR:
            return {
                ...state,
                errorMsg: action.payload,
                loading: false,
                saveBtnLoading: false
            };

        default:
            return state;
    }
};

export default MappingMasterReducer;